import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { useNotification } from "~hooks/useNotification.ts";
import type { LeaderCriteriaRuleResponse } from "~pages/LeaderCriteria/types/leaderCriteriaRule.ts";
import type { UpdateLeaderCriteriaRuleModel } from "~pages/LeaderCriteria/types/leaderCriteriaRuleModel.ts";

export const useUpdateLeaderCriteriaRule = () => {
  const { sport, organizationId, leaderCriteriaId } = useParams();
  const request = useApi();
  const queryClient = useQueryClient();
  const { formatMessage } = useIntl();
  const notification = useNotification();

  return useMutation<LeaderCriteriaRuleResponse, Error, UpdateLeaderCriteriaRuleModel>({
    mutationFn: async ({ qualifierId, ...body }) =>
      await request<LeaderCriteriaRuleResponse>(
        `${sport}/o/${organizationId}/statistics/leaders/criteria/${leaderCriteriaId}/qualifiers/${qualifierId}`,
        {
          method: "PUT",
          body,
        },
      ),
    onSuccess: async () => {
      notification.success({
        message: formatMessage({ id: "rule.update.success" }),
        placement: "bottomRight",
      });

      await queryClient.invalidateQueries({ queryKey: ["leaderCriteriaRules", sport, organizationId, leaderCriteriaId] });
    },
  });
};
